import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RequestService} from '../../../services/request.service';
import {UrlService} from '../../../services/url.service';
import {Formulaire} from '../../../services/formulaire';
import {MyCONST} from '../../../CONST/myCONST';
import {UserService} from '../../../services/user.service';
import {Router} from '@angular/router';
import {SupervisorsocketService} from '../../../services/supervisorsocket.service';
import {IAppSettings} from '../../../interfaces/settings';

import {TranslateService} from '@ngx-translate/core';
import {EnvService} from '../../../services/env.service';
import {environment} from 'environments/environment';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent extends Formulaire implements OnInit {
  loginForm: FormGroup;
  settings: IAppSettings;
  enable_signup: boolean;

  constructor(private fb: FormBuilder, public _request: RequestService,
              public url: UrlService, private user: UserService, private translate: TranslateService,
              private router: Router, private  supervisor_socket: SupervisorsocketService,
              private env: EnvService) {
    super();

    if (supervisor_socket.connected) {
      supervisor_socket.connected = false;
      supervisor_socket.supervisor_socket.disconnect();
    }
  }


  ngOnInit() {
    this.settings = environment.appSettings;
    this.enable_signup = this.settings.enable_signup;
    let uname = localStorage.getItem(MyCONST.username);
    uname = (uname) ? uname : '';

    this.loginForm = this.fb.group({
      pseudo: [uname, [Validators.required]],
      password: [MyCONST.TEST_PWD, [Validators.required]]
    });

    // this.loginForm.valueChanges.subscribe();
  }

  _loginEvent() {
    const loginUrL = this.url.baseurl + 'public/auth';

    // const body = this.convertObjectToFormData(this.loginForm);

    this._request.post(loginUrL, this.loginForm.value).subscribe((results: any) => {
        // console.log('http response', results);
        this.loading = false;
        const status = (results.type === 'bearer') ? 'success' : 'error';
        const msg = this.translate.instant('HOME.txt.login_success_msg');
        this._request.notifySuccess(status, 'Notification', msg);

        this.successResult(results);
      }, error => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  successResult(data) {
    /**
     * when login success
     */
    // console.log(data);
    if (data.type === 'bearer') {
      /*
      reset user info
       */
      localStorage.removeItem(MyCONST.authenticated); // reset user data
      this.user.authenticated = {};

      localStorage.setItem(MyCONST.IsLogin, JSON.stringify(true));
      localStorage.setItem(MyCONST.Token, data.token);
      localStorage.setItem(MyCONST.RefreshToken, data.refreshToken);
      localStorage.setItem(MyCONST.username, this.loginForm.get('pseudo').value);
      // this.router.navigate(['/vertical/default-dashboard']);

      this.get_user_info();
    }
  }

  private get_user_info() {
    this.user.getUserInfo(true).then(results => {
      this.user.authenticated = results;
      let routeToGo = '/vertical/groupes';
      switch (this.user.authenticated.type) {
        case 'seller_admin':
          routeToGo = '/vertical/portal';
          break;
        case 'seller':
          routeToGo = '/vertical/portal';
          break;
        case 'client':
          routeToGo = '/vertical/portal';
          break;
        case 'supervisor':
          routeToGo = '/vertical/claims';
          break;
        default: //  super_admin
          routeToGo = '/vertical/home';
          break;
      }
      this.router.navigate([routeToGo]);
    });
  }
}
